<input type="file"
       class="photo-input"
       [accept]="validExtensions"
       (change)="onFilesSelect($event)"
       #photoInput />

<div class="photo-container">
  <picture>
    <div class="edit-overlay" [ngStyle]="{'display': editing ? 'flex' : 'none'}" (click)="photoInput.click()">
      <mat-icon>photo_camera</mat-icon>
    </div>

    <anon-user-photo [user]="user" [dim]="editing"></anon-user-photo>
  </picture>
</div>
<div class="photo-buttons" [ngStyle]="{'justify-content': editing ? 'space-between' : 'initial'}">
  <ng-container *ngIf="editing; else notEditing">
    <button mat-button [disabled]="loading || this.photo === null || this.photo === undefined" (click)="clear()">Clear</button>
    <div>
      <button mat-raised-button color="accent" (click)="photoInput.click()" [disabled]="loading">{{loading ? 'Changing' : 'Change'}}</button>
      <button mat-stroked-button color="warn" (click)="editing=false" [disabled]="loading">Cancel</button>
    </div>
  </ng-container>
  <ng-template #notEditing>
    <button mat-raised-button color="primary" (click)="editing=true" [disabled]="loading">Edit</button>
  </ng-template>
</div>
